import { createContext } from 'react';

const ConfigurationDataContext = createContext();

export default ConfigurationDataContext;
